export default "__VITE_ASSET__moCNi_IN__";